<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-6">{{ new Date().getFullYear() - 1 }} - {{ new Date().getFullYear() }} © {{empresa.nome}}</div>
        <div class="col-sm-6">
          <div class="text-sm-end d-none d-sm-block">Develop by GW Informática</div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end footer -->
</template>

<script>


import { mapGetters } from 'vuex';

export default {
  computed:{
    //...mapGetters('company', ['getEmpresa']),
    ...mapGetters('company',{
      empresa: 'getEmpresa'
    }),
   /*  empresa(){
      return this.$store.getters.getEmpresa
    }, */
    empresa_old(){
      //let objEmpresa = JSON.stringify({id:1, nome: 'Itiban'})
      //localStorage.setItem("empresa", objEmpresa)
      
      let empresaSelecionada = {}
      empresaSelecionada.nome = 'Empresa'
      
      if((localStorage.getItem("empresa") !== 'undefined') && (localStorage.getItem("empresa") !== null)){
        empresaSelecionada = JSON.parse(localStorage.getItem("empresa"))
      }
      
      return empresaSelecionada.nome
    },

    }
  }

</script>
